import * as React from 'react';
import { Link } from 'react-router-dom';

export interface IHomeProps {
}

export function Home(props: IHomeProps) {
    return (
        <>
            <section className="hero-section">
                <div className="hero-container">
                    <div className="hero-content">
                        <div className="hero-text">
                            <h1 className="hero-title">Vishnu Das</h1>
                            <p className="hero-description">
                                Hello, I am a highly skilled Java Architect with 12 years of experience in designing and developing robust and scalable software solutions. With a deep understanding of Java technologies and architectural principles, I excel in delivering high-quality systems.
                            </p>
                            <div className="hero-button">
                                <Link to="https://vishnumohandaspersonalsa.blob.core.windows.net/static/Vishnu_Resume2025.pdf" target="_blank" className="cta-button">Download CV</Link>
                            </div>
                        </div>
                        <div className="hero-image">
                            <img src="./assets/images/IMG_0830.png" alt="Profile" className="profile-image" />
                        </div>
                    </div>
                    
                    <div className="companies-section">
                        <p className="companies-text">Technologies I Work With</p>
                        <div className="companies-logos">
                            <img src="./assets/images/java.svg" alt="Java" className="company-logo" />
                            <img src="./assets/images/react.svg" alt="React" className="company-logo" />
                            <img src="./assets/images/azure.png" alt="Azure" className="company-logo" />
                            <img src="./assets/images/aws.svg" alt="AWS" className="company-logo" />
                            <img src="./assets/images/docker.svg" alt="Docker" className="company-logo" />
                            <img src="./assets/images/kubernetes.svg" alt="Kubernetes" className="company-logo" />
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
